import { createFileRoute } from '@tanstack/react-router'
import { trpc } from '@viastud/ui/lib/trpc'
import { ContactModal } from '@viastud/ui/shared/contact-modal'
import { SupportPage } from '@viastud/ui/shared/support-page'

import { SupportContact } from '@/components/profile/support-contact'
import { useProfilePresenter } from '@/presenters/profile.presenter'
import { useAuthStore } from '@/store/auth.store'

export const Route = createFileRoute('/_student/_layout/support')({
  component: SupportPageContent,
})

function SupportPageContent() {
  const { data: faqContentData } = trpc.faq.getAll.useQuery()
  const profilePresenter = useProfilePresenter()

  const { user } = useAuthStore()
  if (!user) return

  return (
    <div className="flex w-full flex-col items-center">
      <SupportPage
        faqContent={faqContentData ?? []}
        user={user}
        onContactClick={profilePresenter.handleContactSupport}
      />
      <div className="mb-12 mt-8 flex w-4/5 flex-col gap-6 md:w-3/5">
        <SupportContact presenter={profilePresenter} />
      </div>
      <ContactModal
        {...user}
        open={profilePresenter.isContactModalOpen}
        onOpenChange={profilePresenter.setIsContactModalOpen}
        showTrigger={false}
      />
    </div>
  )
}
